import { useExperimentVariant } from 'src/utils/experimentNew'
import { Experiments } from '../constants'

type Variant = 'control' | 'treatment'

const EXPERIMENT_KEY = Experiments.SsrRendererService

export function useSsrRendererServiceExperiment() {
  const { value: variant } = useExperimentVariant<Variant>(
    EXPERIMENT_KEY,
    'control',
  )

  return {
    variant,
    isTreatment: variant === 'treatment',
  }
}
